import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./ProgramsPage.css";



export default function ProgramsPage() {
  const [items, setItems] = useState([]);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(true);
const MOBILE = window.innerWidth <= 1024;
const CARD_W = MOBILE ? 110 : 260;


const IMG_H = Math.round(CARD_W * 7.884 / 5.239);

const CARD_H = IMG_H;
const GAP = 8;  
  const BUFFER_ROWS = 3;

  const gridRef = useRef(null);

  const [layout, setLayout] = useState({
    width: 0,
    height: 0,
    perRow: 1,
    rowHeight: CARD_H + GAP,
    gridTopOnPage: 0,
    isMobile: false,   
  });

  const [windowState, setWindowState] = useState({ startRow: 0, endRow: 0 });


useEffect(() => {
  setLoading(true);
  setItems([]);

  (async () => {
    try {
      const res = await fetch("/api/content/programs", {
        headers: { Accept: "application/json" },
      });

      const text = await res.text();
      let data = null;
      try {
        data = text ? JSON.parse(text) : null;
      } catch {}

      if (!res.ok) {
        throw new Error(
          data?.error || data?.message || text || `HTTP ${res.status}`
        );
      }

      const arr = Array.isArray(data?.programs)
        ? data.programs
        : Array.isArray(data)
        ? data
        : [];

    
      console.log(
        "PROGRAMS FROM API:",
        arr.map((p) => ({ id: p.id, sort_order: p.sort_order }))
      );

 
      const cleaned = arr
        .filter(Boolean)
        .map((p) => {
      
          let so = p.sort_order;
          if (so === null || so === undefined || so === "") {
            so = 999999; 
          }
          const num = Number(so);
          return { ...p, sort_order: Number.isFinite(num) ? num : 999999 };
        })
        .sort((a, b) => a.sort_order - b.sort_order);

      console.log(
        "AFTER SORT:",
        cleaned.map((p) => ({ id: p.id, sort_order: p.sort_order }))
      );

      setItems(cleaned);

    } catch (e) {
      setErr(e?.message || "خطأ غير معروف");
    } finally {
      setLoading(false);
    }
  })();
}, []);




  const getPageScrollY = () =>
    window.pageYOffset || document.documentElement.scrollTop || 0;

  const computeGridTopOnPage = (el) => {
    if (!el) return 0;
    let top = 0;
    let node = el;
    while (node) {
      top += node.offsetTop || 0;
      node = node.offsetParent;
    }
    return top;
  };

  
  useLayoutEffect(() => {
    const updateLayout = () => {
      const grid = gridRef.current;
      if (!grid) return;

      const width = grid.clientWidth;
      const height = window.innerHeight;


      const mobileBreakpoint = 1024; 
      const isMobile = window.innerWidth <= mobileBreakpoint || matchMedia("(pointer: coarse)").matches;

let perRow;

if (isMobile) {
  perRow = 3;
} else {
  perRow = Math.max(1, Math.floor((width + GAP) / (CARD_W + GAP)));
}

      const rowHeight = CARD_H + GAP;
      const gridTopOnPage = computeGridTopOnPage(grid);
      setLayout({ width, height, perRow, rowHeight, gridTopOnPage, isMobile });
    };

    updateLayout();
    window.addEventListener("resize", updateLayout);
    const ro = new ResizeObserver(updateLayout);
    if (gridRef.current) ro.observe(gridRef.current);

    return () => {
      window.removeEventListener("resize", updateLayout);
      ro.disconnect();
    };
    
  }, []);


  useEffect(() => {
    if (layout.isMobile) return; 

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const { rowHeight, gridTopOnPage } = layout;
        const viewportTop = getPageScrollY();
        const viewportH = window.innerHeight;

        const localScrollTop = Math.max(0, viewportTop - gridTopOnPage);

        const nextStartRow = Math.max(0, Math.floor(localScrollTop / rowHeight) - BUFFER_ROWS);
        const nextEndRow = Math.floor((localScrollTop + viewportH) / rowHeight) + BUFFER_ROWS;

        setWindowState((prev) => {
          if (prev.startRow === nextStartRow && prev.endRow === nextEndRow) return prev;
          return { startRow: nextStartRow, endRow: nextEndRow };
        });

        ticking = false;
      });
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [layout]);

  if (err) {
    return (
      <main dir="rtl" className="programs-main">
        حدث خطأ: {err}
      </main>
    );
  }

 
  const total = items.length;
  const { perRow, rowHeight, isMobile } = layout;
  const itemsPerRow = Math.max(1, perRow);



  const totalRows = Math.max(1, Math.ceil(total / itemsPerRow));
  const totalHeight = totalRows * rowHeight;

  const startRow = Math.min(windowState.startRow, Math.max(0, totalRows - 1));
  const endRow = Math.min(windowState.endRow, totalRows - 1);

  const sliceStart = startRow * itemsPerRow;
  const sliceEnd = Math.min(total, (endRow + 1) * itemsPerRow);
  const visibleItems = items.slice(sliceStart, sliceEnd);

  const translateY = startRow * rowHeight;

  return (
    <main dir="rtl" className="programs-main">
      {loading && <div className="programs-loading">جارٍ التحميل…</div>}

      <div ref={gridRef} className="programs-grid-wrapper">
        <div className="programs-list" style={{ height: totalHeight }}>
          <div className="programs-visible-window" style={{ transform: `translateY(${translateY}px)` }}>
          <div
  className="programs-grid"
  style={{
    gridTemplateColumns: `repeat(${itemsPerRow}, ${CARD_W}px)`,
    justifyContent: "center",
  }}
>
              {visibleItems.map((p, i) => {
                if (!p || typeof p !== "object") return null;
                const idx = sliceStart + i;
                const slugOrId = p.slug || p.id || p.day || `i-${idx}`;
                const img = p.cover_url || p.image_url || p.thumbnail || p.image;
                const title = p.title || p.name || "— بدون عنوان —";
                const href = `/programs/${encodeURIComponent(slugOrId)}`;
                return (
                  <Card
                    key={slugOrId}
                    href={href}
                    title={title}
                    img={img}
                    CARD_W={CARD_W}
                    CARD_H={CARD_H}
                    IMG_H={IMG_H}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}


const Card = React.memo(function Card({ href, title, img, CARD_W, CARD_H, IMG_H }) {
  return (
    <Link to={href} className="card-link">
      <article className="pc-card" style={{ width: CARD_W, height: CARD_H }}>
        <div className="image-wrap">
          {img ? (
            <img
              src={img}
              alt={title}
              loading="lazy"
              decoding="async"
              crossOrigin="anonymous"
            />
          ) : (
            <div className="img-placeholder">—</div>
          )}
        </div>
        <div className="pc-card-body">{/* فارغ */}</div>
      </article>
    </Link>
  );
});
